import { useEffect, useState } from 'react';
import { T } from '../../components/text/TextEdit';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { api } from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { SectionCard, Field } from '../pipeline/ui';

// User-facing "Your referral link" card. Fetches/creates the user's referral code and shows a
// copyable share link. Additive — no restructure of Settings.
export default function ReferralCard() {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.out('get_referral_link')
      .then((r) => setCode(r.code || ''))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const link = code ? `${window.location.origin}/register?ref=${encodeURIComponent(code)}` : '';
  const copy = () => {
    if (!link) return;
    navigator.clipboard?.writeText(link);
    toast.success(t('referral.copied'));
  };

  return (
    <SectionCard title={t('referral.title')} testId="referral-card">
      <p className="text-sm text-muted-foreground -mt-2"><T k="referral.hint" /></p>
      <div className="flex flex-wrap items-end gap-3">
        <Field label={<T k="referral.linkLabel" />}>
          <Input value={loading ? t('referral.loading') : link} readOnly data-testid="referral-link" className="w-96" />
        </Field>
        <Button onClick={copy} disabled={!code} data-testid="referral-copy"><T k="referral.copy" /></Button>
      </div>
    </SectionCard>
  );
}
